module.exports = __webpack_public_path__ + "static/media/tan_arrow.0a116155.svg";